export default (state) => {
  window.dispatchEvent(
    new CustomEvent('capacityChange', {
      detail: { state },
    })
  );
};
